
  import { Vue, Component, Prop } from "vue-property-decorator";

  import GET_INDUSTIES from "@/apollo/autocomplete-queries/GetIndustries.gql";

  import DropdownFilter from "@/components/filters/DropdownFilterNew.vue";

  import DropdownOption from "@/entities/DropdownOption";
  import { Query_RootIndustryArgs } from "@/generated/graphql";

  @Component({
    components: {
      DropdownFilter,
    },
    apollo: {
      industries: {
        query: GET_INDUSTIES,
        variables() {
          return this.skillAutocompleteFilter;
        },
        update(data) {
          return data.industry;
        },
        skip() {
          return !this.industrySearchString;
        },
      },
    },
  })
  export default class IndustriesMultiselect extends Vue {
    @Prop({ required: true, type: Array }) value!: DropdownOption[];
    @Prop({ default: true, type: Boolean }) withBorder!: boolean;
    @Prop({ default: 5, type: Number }) limit!: number;
    @Prop({ type: Number, default: undefined }) readonly max?: number;
    @Prop({ default: true, type: Boolean }) multiple!: boolean;
        @Prop({ default: "Enter keyword to search industry", type: String }) readonly placeholder!: string;
            @Prop({ type: String, default: "customWidthInput" }) readonly getcontainerStyle?: string;


    industries: DropdownOption[] = [];
    industrySearchString: string = "";

    get mappedIndustriesValue(): String[] {
      return this.value.map((item) => item.name);
    }

    get skillAutocompleteFilter(): Query_RootIndustryArgs {
      const conditions: any[] = [
        {
          name: {
            _ilike: `%${this.industrySearchString}%`,
          },
        },
      ];

      if (this.mappedIndustriesValue.length) {
        conditions.push({
          name: {
            _nin: this.mappedIndustriesValue,
          },
        });
      }

      return {
        where: { _and: conditions },
        limit: this.limit,
      };
    }

    handleInput(val: DropdownOption[]) {
      this.$emit("input", val);
    }
  }
